/** Retained legacy route: 1% tolerance rounded down, with a 300-second review. */
export function redeemProtection(expectedPayoutWei: bigint, nowSeconds: number) {
  if (expectedPayoutWei <= 0n || expectedPayoutWei >= 1n << 256n) throw new Error("PayoutIsZero: A positive uint256 payout is required.");
  if (!Number.isSafeInteger(nowSeconds) || nowSeconds < 0 || !Number.isSafeInteger(nowSeconds + 300)) throw new Error("Invalid quote timestamp");
  const minimumPayoutWei = expectedPayoutWei * 9900n / 10000n;
  if (minimumPayoutWei === 0n) throw new Error("The minimum payout rounds to zero. Redemption protection is unavailable.");
  return { minimumPayoutWei, deadline: nowSeconds + 300 };
}

/** New sweep route: freeze this result when review is created, never on confirm. */
export function redeemWithFeesProtection(quotedPayoutWei: bigint, reviewCreatedAtSeconds: number) {
  if (typeof quotedPayoutWei !== "bigint" || quotedPayoutWei <= 0n || quotedPayoutWei >= (1n << 256n)) {
    throw new Error("PayoutIsZero: A positive uint256 payout is required.");
  }
  if (!Number.isSafeInteger(reviewCreatedAtSeconds) || reviewCreatedAtSeconds < 0 ||
    !Number.isSafeInteger(reviewCreatedAtSeconds + 600)) throw new Error("Invalid review timestamp");
  return { minimumPayoutWei: quotedPayoutWei, deadline: reviewCreatedAtSeconds + 600 };
}
